export enum IresaResponseStatusEnum {
    SUCCESS = "Success",
    FAILURE = "Failure",
    PARTIAL= "Partial"
}